import { render, staticRenderFns } from "./AddManual.vue?vue&type=template&id=49088683&scoped=true&"
import script from "./AddManual.vue?vue&type=script&lang=ts&"
export * from "./AddManual.vue?vue&type=script&lang=ts&"
import style0 from "./AddManual.vue?vue&type=style&index=0&id=49088683&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49088683",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
